import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from '../Base/Layout';
import ReactModal from 'react-modal';
import OrdersApi from '../../api/Orders';

class ServicePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            telephone: "",
            email: "",
            attachment: null,
            comment: "",
            showConfirmModal: false,

            editorActive: false,
            hasChange: false
        };

        this.findService = this.findService.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    findService() {
        let serviceName = this.props.match.params.id;
        let {services} = this.props;

        if (services == undefined || services.length == 0) {
            return "";
        }

        let service = services.filter(e => e.name === serviceName)[0];
        return service != undefined ? service : "";
    }

    handleSubmit(e) {
        e.preventDefault();

        let d = {
            serviceType: "SERVICE_ORDER",
            userName: this.state.name,
            contactData: this.state.telephone + " " + this.state.email,
            comments: this.state.comment,
            languageName: "todo",
            extraData: this.findService().name
        };
        if (this.state.attachment != null) {
            OrdersApi.createWithFiles(d, this.state.attachment).then(e => {
                this.setState({showConfirmModal: true});
            });
            return;
        }

        OrdersApi.create(d).then(e => {
            this.setState({showConfirmModal: true});
        })

    }

    render() {
        let {i18n} = this.props;

        let service = this.findService();
        let title = service != undefined ? service.title : null;

        return (
            <Layout
                showPromoContent={false}
                title={title}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <a href="/" className="cancel">{i18n['service.feedback.back']}</a>
                        <div className="clearfix heading">
                            <h2>
                                {title}
                            </h2>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: service != null ? service.html : ''}} style={{minHeight: '100px'}}></div>

                        <div className="clearfix form-contact form-service">
                            <span>{i18n['service.feedback.title']}</span>
                            <div>
                                <form>
                                    <fieldset>
                                        <input type="text" placeholder={i18n['service.feedback.fio']}
                                               value={this.state.name} onChange={e => {
                                            this.setState({name: e.target.value})
                                        }}/>
                                        <input type="text" placeholder={i18n['service.feedback.phone']}
                                               value={this.state.telephone} onChange={e => {
                                            this.setState({telephone: e.target.value})
                                        }}/>
                                    </fieldset>
                                    <fieldset>
                                        <input type="text" placeholder={i18n['service.feedback.email']}
                                               value={this.state.email} onChange={e => {
                                            this.setState({email: e.target.value})
                                        }}/>
                                        <label>
                                            {this.state.attachment === null ? i18n['service.feedback.attach'] : this.state.attachment.map(e => e[1].name).join(",")}
                                            <input type="file" onChange={e => {
                                                let a = [];
                                                Object.entries(e.target.files).forEach(item => {
                                                    a.push(item)
                                                });
                                                this.setState({attachment: a});
                                            }} multiple/>
                                        </label>
                                    </fieldset>
                                    <fieldset>
                                        <textarea placeholder={i18n['service.feedback.comment']}
                                                  value={this.state.comment} onChange={e => {
                                            this.setState({comment: e.target.value})
                                        }}/>
                                    </fieldset>
                                    <i/>
                                    <input type="submit" value={i18n['service.feedback.send']}
                                           onClick={this.handleSubmit}/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <ReactModal
                    className="custom-react-modal"
                    isOpen={this.state.showConfirmModal}
                    overlayClassName="custom-react-modal-overlay"
                >
                    {i18n['objectPage.callbackConfirmMessage']}
                    <br/><br/>
                    <button onClick={() => {
                        this.setState({showConfirmModal: false})
                    }} className="btn">
                        {i18n['objectPage.callbackClose']}
                    </button>
                </ReactModal>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    services: state.configuration.services,
    currentUser: state.user.currentUser,
    languageCode: state.languages.currentLanguage.code
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicePage);



// WEBPACK FOOTER //
// ./src/components/Service/ServicePage.js